<script lang="ts" setup></script>
<template>
  <div
    class="search-overlay position-absolute start-0 w-100 vh-100 bg-black"
  />
</template>
<style lang="scss" scoped>
@import './SearchResultsOverlay.scss';
</style>
